

import React from 'react'
import * as Sentry from "@sentry/react";

export const startSentry = (env) => {
  if(env?.SENTRY_DSN_FRONTEND) {
    Sentry.init({
      dsn: env.SENTRY_DSN_FRONTEND,
      integrations: [],
      environment: env?.NX_APPNAME,
      traces_sample_rate: env?.SENTRY_TRACES_SAMPLE_RATE_FRONTEND ?? 1.0,
      release: env?.RELEASE
    });
  }
}

const sentryOptions =  {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
};

export default sentryOptions